import { createFileRoute } from '@tanstack/react-router';
import { Trans } from '@lingui/react/macro';
import NewsPage from '@/pages/static/NewsPage';
import NotFoundPage from '@/components/NotFoundPage';
import { useCurrentUser } from '@/services/userHooks';

export const Route = createFileRoute('/news')({
  component: NewsRoute,
});

/**
 * News is an unlisted beta gated on config.NEWS_TESTER_USERNAMES. This mirrors
 * the server-side gate for presentation only -- the SPA bundle is public, so
 * /data/news 404ing for non-testers is the actual protection. Non-testers get
 * the same 404 page as a bad URL rather than a feed that can never load.
 */
export function NewsRoute() {
  const { currentUser, isLoading } = useCurrentUser();

  // The session is what decides page vs. 404, so hold the route on a loading
  // line until it resolves rather than flashing a 404 at a real tester.
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white text-gray-400">
        <Trans>Loading…</Trans>
      </div>
    );
  }

  return currentUser?.newsBeta ? <NewsPage /> : <NotFoundPage />;
}
